import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'
import * as XLSX from 'xlsx'

import './Templates.css'

import CreateEditTemplate from './CreateEditTemplate'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchTemplate,
    fetchTemplateError,
    createTemplate,
    updateTemplate,
    errorTemplate,
    validateFilterSQL,
    applyFormula,
    fetchTemplatesList,
    getProductGroupCount,
    exportTemplate,
    importTemplate
} from './actions'

import { fetchSeriesList } from '../ProductSeries/actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'


var Spinner = require('react-spinkit');

let chkReturn = 0;

class Templates extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editTemplate: false,
            editTemplateMode: false,
            showFilterProducts: true,

            nameSrch: '',
            template: {
                name: '',
                published: 0,
                filter: "",
                productGroupCount: null,
                websiteCategory1: "",
                websiteCategory2: "",
//&?                priority: 0,
                productSeriesId: 0,
                groupMetaClassName: "",
                metaClassName: "",
                groupPageLayoutDefault: "",
                createdBy: "",
                lastUpdatedAt: "",
                productTemplateLanguages: [
                    {
                        language: "",

                        groupCode: "",
                        groupName: "",
                        groupDescription: "",
                        groupURL: "",
                        groupSEDescription: "",
                        groupSETitle: "",
                        groupSEKeywords: "",
                        groupActive: "",
                        groupStartDate: '@ConvertDate("2018-01-01")@',
                        groupEndDate: '@ConvertDate("2099-12-31")@',
                        groupMappedToReicoSite: "",
                        groupMappedToDistributorSite: "",
                        code: "",
                        name: "",
                        description: "",
                        active: "",
                        startDate: '@ConvertDate("2018-01-01")@',
                        endDate: '@ConvertDate("2099-12-31")@',
                        manufacturerPartNumber: "[BRPART]",
                        gtin: "[BRUPC]",
                        imageOverride: "",
                        overrideImageBaseName: "",
                        swatchImageName: "",
                        colorSwatch: "",
                        colorTraitName: "",
                        colorTraitValue: "",
                        trait1Name: "",
                        trait1Value: "",
                        trait2Name: "",
                        trait2Value: "",
                        minimumQty: "1",
                        maximumQty: "999999",
                        inStockQuantity: "",
                        weight: "[BRWEIGHT]",
                        showQuoteButton: "@true@",
                        showBuyButton: "@false@",
                        hidePriceUntilCart: "@false@",
                        regularPrice: "",
                        salePrice: "",
                        msrpPrice: "[BRMSRP]",
                        mapPrice: ""
                    }
                ]
            }
        };

        this.fetchTemplateErrorClear = this.fetchTemplateErrorClear.bind(this);
        this.errorTemplateClear = this.errorTemplateClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.templateEdit = this.templateEdit.bind(this);
        this.templateEditVerify = this.templateEditVerify.bind(this);

        this.templateCreate = this.templateCreate.bind(this);
        this.templateCreateVerify = this.templateCreateVerify.bind(this);

        this.startImport = this.startImport.bind(this);
        this.startExport = this.startExport.bind(this);
        this.onImport = this.onImport.bind(this);

        this.updateTemplate = this.updateTemplate.bind(this);
        this.cancelTemplate = this.cancelTemplate.bind(this);
        this.closeTemplate = this.closeTemplate.bind(this);

        this.onSeries = this.onSeries.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChange2 = this.onChange2.bind(this);

        this.search = this.search.bind(this);

        this.validateSQL = this.validateSQL.bind(this);
        this.calculateProductGroupCount = this.calculateProductGroupCount.bind(this);

        this.formulaValidate = this.formulaValidate.bind(this);
        this.setWebCategories = this.setWebCategories.bind(this);
        this.afterOpen = this.afterOpen.bind(this);
        this.findProductsWithDifferentTemplateId = this.findProductsWithDifferentTemplateId.bind(this);
        this.canPublish = this.canPublish.bind(this);
        this.canDraft = this.canDraft.bind(this);

        this.closeFilterProducts = this.closeFilterProducts.bind(this);
    }

    componentDidMount() {
        if (!this.props.seriesList.length)
            this.props.dispatch(fetchSeriesList)
    }

    onSeries() {
        let code = '';
        let seriesId = parseInt($('select.series').val());

        let series = this.props.seriesList.filter((ser) => {
            return ser.productSeriesId === seriesId
        })

        series[0].reicoSkuBricks.forEach((brk) => {
            if (code.length)
                code = code + '.';

            code = code + '#' + brk.name + '#';
        })

        $('textarea[name=code]').val(code)

        if (this.props.template.filter) {
            applyFormula.bind(this)({
                productSeriesId: seriesId,
                productMasterId: this.props.template.filter.productMasterId,
                formulaName: 'code',
                formulaExpression: code
            })
        }

        this.onChange()
    }

    onChange() {
//&?
/*
        let priority = parseInt($('#template_priority').val())

        if (priority && priority > 0)
            $('#template_priority').val(priority)
        else {
            $('#template_priority').val(0)
        }
*/
        if (!$('#template_name').val() || !$('select.series').val())
            $('button.draft').attr('disabled', 'disabled')

        this.canPublish()
    }

    onChange2() {
        this.canPublish()
        $('#calculateProductGroupCountBtn').attr('disabled', 'disabledOnChange');
    }

    formulaValidate(e) {
        if (e.currentTarget.readOnly)
            return

        applyFormula.bind(this)({
            productSeriesId: parseInt($('select.series').val()),
            productMasterId: this.props.template.filter.productMasterId,
            formulaName: e.currentTarget.attributes.name.value,
            formulaExpression: e.currentTarget.value
        })

        if (e.currentTarget.attributes.name.value == 'groupCode') {
            this.validateSQL()
        }
    }

    setWebCategories(web1, web2) {
        if ((this.state.editTemplate || this.state.copyTemplate) && web1 && web1 !== "")
            $('select.web1').val(web1)

        if ((this.state.editTemplate || this.state.copyTemplate) && web2 && web2 !== "")
            $('select.web2').val(web2)
    }

    afterOpen() {
        if ($('#template_name').attr('published') === '1') {
            $('#template_name').attr('disabled', 'disabled')
            $('select.series').attr('disabled', 'disabled')
        }

        let web1 =
            !this.state.editTemplate || this.state.template.websiteCategory1 !== "" ?
                this.state.template.websiteCategory1
            :
                this.props.template.template.websiteCategory1 !== "" ?
                    this.props.template.template.websiteCategory1
                :
                    ""

        let web2 =
            !this.state.editTemplate || this.state.template.websiteCategory2 !== "" ?
                this.state.template.websiteCategory2
            :
                this.props.template.template.websiteCategory2 !== "" ?
                    this.props.template.template.websiteCategory2
                :
                    ""

        if (this.props.template.categories.length) {
            this.setWebCategories(web1, web2)
        }
        else {
            let intr = setInterval(() => {
                if (this.props.template.categories.length) {
                    clearInterval(intr)
                    this.setWebCategories(web1, web2)
                }
            }, 200)
        }

        let series =
            !this.state.editTemplate || this.state.template.productSeriesId !== 0 ?
                this.state.template.productSeriesId
            :
                this.props.template.template.productSeriesId !== 0 ?
                    this.props.template.template.productSeriesId
                :
                    0

        $('select.series').val(series)

        let grpmeta =
            !this.state.editTemplate || this.state.template.groupMetaClassName !== "" ?
                this.state.template.groupMetaClassName
            :
                this.props.template.template.groupMetaClassName !== "" ?
                    this.props.template.template.groupMetaClassName
                :
                    ""

        $('select.grpmeta').val(grpmeta)

        let meta =
            !this.state.editTemplate || this.state.template.metaClassName !== "" ?
                this.state.template.metaClassName
            :
                this.props.template.template.metaClassName !== "" ?
                    this.props.template.template.metaClassName
                :
                    ""

        $('select.meta').val(meta)

        let layout =
            !this.state.editTemplate || this.state.template.groupPageLayoutDefault !== "" ?
                this.state.template.groupPageLayoutDefault
            :
                this.props.template.template.groupPageLayoutDefault !== "" ?
                    this.props.template.template.groupPageLayoutDefault
                :
                    ""

        $('select.layout').val(layout)

        if ((this.state.editTemplate || this.state.copyTemplate) && $('#template_filter').val().length) {
            let id = this.state.copyTemplate ?
                    parseInt(this.state.copyTemplateId)
                :
                    parseInt($('#template_id').text())

            validateFilterSQL.bind(this)({ filterExpression: $('#template_filter').val() }, id)
         }
        else if (!this.props.template.error)
            this.props.dispatch(
            {
                type: "INIT_TEMPLATE"
            }
        )

        this.canPublish();
    }

    findProductsWithDifferentTemplateId() {
        if (!!this.props.template.filter && !!this.props.template.filter.products) {
            return this.props.template.filter.products.filter(prod => !!prod.productTemplateId && prod.productTemplateId != this.props.template.template.productTemplateId)
        } else {
            return [];
        }
    }

    canPublish() {
        if (!$('#template_name').val() ||
            !$('#template_filter').val() ||
            !$('select.web1').val() || $('select.web1').val() === 'Select' ||
            !$('select.series').val() ||
//&?            !($('#template_priority').val() > 0) ||
            !$('select.grpmeta').val() ||
            !$('select.meta').val() ||
            !$('select.layout').val() ||

            !$('textarea[name="groupCode"]').val() ||
            !$('textarea[name="groupName"]').val() ||
            !$('textarea[name="groupURL"]').val() ||
            !$('textarea[name="groupSETitle"]').val() ||
            !$('textarea[name="groupSEDescription"]').val() ||
            !$('textarea[name="groupActive"]').val() ||
            !$('textarea[name="groupStartDate"]').val() ||
            !$('textarea[name="groupEndDate"]').val() ||
            !$('textarea[name="groupMappedToReicoSite"]').val() ||
            !$('textarea[name="groupMappedToDistributorSite"]').val() ||
            !$('textarea[name="code"]').val() ||
            !$('textarea[name="name"]').val() ||
            !$('textarea[name="active"]').val() ||
            !$('textarea[name="startDate"]').val() ||
            !$('textarea[name="endDate"]').val() ||
            !$('textarea[name="showQuoteButton"]').val() ||
            !$('textarea[name="showBuyButton"]').val() ||
            !$('textarea[name="hidePriceUntilCart"]').val() ||
            !$('textarea[name="minimumQty"]').val() ||
            !$('textarea[name="maximumQty"]').val() ||
            !$('textarea[name="inStockQuantity"]').val()
        )
            this.setState({ canPublish: false })
        else 
            this.setState({ canPublish: true })

        this.canDraft()
    }

    canDraft() {
        if (!$('#template_name').val() ||
            !$('select.series').val() ||
            !$('#template_filter').val() ||
            $('button.draft').attr('published') === '1')
            this.setState({ canDraft: false })
        else
            this.setState({ canDraft: true })
    }

    validateSQL() {
        if ($('#template_filter').val().length) {
            let groupCode = null
            let formulas = []

            if (this.state.editTemplate) {
                for (let [key, value] of Object.entries(this.props.template.formulas)) {
                    if (value["formulaExpression"] && value["formulaExpression"].length) {
                        formulas.push(
                            {
                                formulaName: key,
                                formulaExpression: value["formulaExpression"]
                            }
                        )

                        if (key == 'groupCode')
                            groupCode = value["formulaExpression"]
                    }
                }
                this.setState({ showFilterProducts: true })
            } else {
                for (let [key, value] of Object.entries(this.state.template.productTemplateLanguages[0])) {
                    if (value && value.length) {
                        formulas.push(
                            {
                                formulaName: key,
                                formulaExpression: value
                            }
                        )

                        if (key == 'groupCode') groupCode = value;
                    }
                }
            }

            validateFilterSQL.bind(this)(
                { filterExpression: $('#template_filter').val() },
                null,
                $('select.series').val(),
                formulas,
                groupCode,
                this.props.template.filter ? this.props.template.filter.productMasterId : null)

            var countBtn = $('#calculateProductGroupCountBtn');
            if (countBtn.attr('disabled') == "disabledOnChange") countBtn.removeAttr('disabled');
        } else {
            this.props.dispatch(errorTemplate);
        }
    }

    calculateProductGroupCount() {
        getProductGroupCount.bind(this)(
            this.props.template.filter.filterExpression || $('#template_filter').val(),
            this.props.template.productSeriesId || $('select.series').val(),
            this.props.template.formulas.groupCode.formulaExpression || $('textarea[name="groupCode"]').val() 
        );
    }

    fetchTemplateErrorClear() {
        this.props.dispatch(fetchTemplateError);
    }

    errorTemplateClear(e) {
        this.props.dispatch(errorTemplate);

        if (e.currentTarget.attributes.code && e.currentTarget.attributes.code.value === "409")
            fetchTemplate.bind(this)(e.currentTarget.attributes.id.value);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    templateEdit(e) {

        if (chkReturn || this.props.templates.fetching) return;
        chkReturn = 1;

        let id = e.target.attributes.template.value;

        this.setState({
            template: {
                name: '',
                published: 0,
                filter: "",
                websiteCategory1: "",
                websiteCategory2: "",
//&?                priority: 0,
                productSeriesId: 0,
                groupMetaClassName: "",
                metaClassName: "",
                groupPageLayoutDefault: "",
                createdBy: "",
                lastUpdatedAt: "",
                productTemplateLanguages: [
                    {
                        language: "",

                        groupCode: "",
                        groupName: "",
                        groupDescription: "",
                        groupURL: "",
                        groupSEDescription: "",
                        groupSETitle: "",
                        groupSEKeywords: "",
                        groupActive: "",
                        groupStartDate: '@ConvertDate("2018-01-01")@',
                        groupEndDate: '@ConvertDate("2099-12-31")@',
                        groupMappedToReicoSite: "",
                        groupMappedToDistributorSite: "",
                        code: "",
                        name: "",
                        description: "",
                        active: "",
                        startDate: '@ConvertDate("2018-01-01")@',
                        endDate: '@ConvertDate("2099-12-31")@',
                        manufacturerPartNumber: "[BRPART]",
                        gtin: "[BRUPC]",
                        imageOverride: "",
                        overrideImageBaseName: "",
                        swatchImageName: "",
                        colorSwatch: "",
                        trait1Name: "",
                        trait1Value: "",
                        trait2Name: "",
                        trait2Value: "",
                        minimumQty: "1",
                        maximumQty: "999999",
                        inStockQuantity: "",
                        weight: "[BRWEIGHT]",
                        showQuoteButton: "@true@",
                        showBuyButton: "@false@",
                        hidePriceUntilCart: "@false@",
                        regularPrice: "",
                        salePrice: "",
                        msrpPrice: "[BRMSRP]",
                        mapPrice: ""
                    }
                ]
            }
        });

        fetchTemplate.bind(this)(id);
        chkReturn = setInterval(this.templateEditVerify, 100);
    }
    templateEditVerify() {
        if (this.props.template.updated || this.props.template.error) {
            if (this.props.template.updated) {
                this.setState({
                    editTemplate: true,
                    editTemplateMode: true
                });
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    templateCreate(e) {
        if (this.props.templates.fetching) return

        if (e.target.attributes.template) {

            if (chkReturn) return;
            chkReturn = 1;

            let id = e.target.attributes.template.value;

            this.setState({ copyTemplateId: id });

            fetchTemplate.bind(this)(id);
            chkReturn = setInterval(this.templateCreateVerify, 100);
        }
        else {
            this.setState({
                copyTemplate: false,
                editTemplate: false,
                editTemplateMode: true,

                template: {
                    name: '',
                    published: 0,
                    filter: "",
                    websiteCategory1: "",
                    websiteCategory2: "",
//&?                    priority: 0,
                    productSeriesId: 0,
                    groupMetaClassName: "",
                    metaClassName: "",
                    groupPageLayoutDefault: "",
                    createdBy: "",
                    lastUpdatedAt: "",
                    productTemplateLanguages: [
                        {
                            language: "",

                            groupCode: "",
                            groupName: "",
                            groupDescription: "",
                            groupURL: "",
                            groupSEDescription: "",
                            groupSETitle: "",
                            groupSEKeywords: "",
                            groupActive: "",
                            groupStartDate: '@ConvertDate("2018-01-01")@',
                            groupEndDate: '@ConvertDate("2099-12-31")@',
                            groupMappedToReicoSite: "",
                            groupMappedToDistributorSite: "",
                            code: "",
                            name: "",
                            description: "",
                            active: "",
                            startDate:'@ConvertDate("2018-01-01")@',
                            endDate: '@ConvertDate("2099-12-31")@',
                            manufacturerPartNumber: "[BRPART]",
                            gtin: "[BRUPC]",
                            imageOverride: "",
                            overrideImageBaseName: "",
                            swatchImageName: "",
                            colorSwatch: "",
                            colorTraitName: "",
                            colorTraitValue: "",
                            trait1Name: "",
                            trait1Value: "",
                            trait2Name: "",
                            trait2Value: "",
                            minimumQty: "1",
                            maximumQty: "999999",
                            inStockQuantity: "",
                            weight: "[BRWEIGHT]",
                            showQuoteButton: "@true@",
                            showBuyButton: "@false@",
                            hidePriceUntilCart: "@false@",
                            regularPrice: "",
                            salePrice: "",
                            msrpPrice: "[BRMSRP]",
                            mapPrice: ""
                        }
                    ]
                }
            });
        }
    }
    templateCreateVerify() {
        if (this.props.template.updated || this.props.template.error) {
            this.setState({
                copyTemplate: true,
                editTemplate: false,
                editTemplateMode: true,

                template: {
                    name: this.props.template.template.name + ' - Copy',
                    published: 0,
                    filter: this.props.template.template.filter,
                    websiteCategory1: this.props.template.template.websiteCategory1,
                    websiteCategory2: this.props.template.template.websiteCategory2,
//&?                    priority: this.props.template.template.priority,
                    productSeriesId: this.props.template.template.productSeriesId,
                    groupMetaClassName: this.props.template.template.groupMetaClassName,
                    metaClassName: this.props.template.template.metaClassName,
                    groupPageLayoutDefault: this.props.template.template.groupPageLayoutDefault,
                    createdBy: this.props.template.template.createdBy,
                    lastUpdatedAt: this.props.template.template.lastUpdatedAt,
                    productTemplateLanguages: [
                        {
                            // unfortunately react won't let us assign these fields programmatically
                            language: this.props.template.template.productTemplateLanguages[0].language,

                            groupCode: this.props.template.template.productTemplateLanguages[0].groupCode,
                            groupName: this.props.template.template.productTemplateLanguages[0].groupName,
                            groupDescription: this.props.template.template.productTemplateLanguages[0].groupDescription,
                            groupURL: this.props.template.template.productTemplateLanguages[0].groupURL,
                            groupSEDescription: this.props.template.template.productTemplateLanguages[0].groupSEDescription,
                            groupSETitle: this.props.template.template.productTemplateLanguages[0].groupSETitle,
                            groupSEKeywords: this.props.template.template.productTemplateLanguages[0].groupSEKeywords,
                            groupActive: this.props.template.template.productTemplateLanguages[0].groupActive,
                            groupStartDate: this.props.template.template.productTemplateLanguages[0].groupStartDate,
                            groupEndDate: this.props.template.template.productTemplateLanguages[0].groupEndDate,
                            groupMappedToReicoSite: this.props.template.template.productTemplateLanguages[0].groupMappedToReicoSite,
                            groupMappedToDistributorSite: this.props.template.template.productTemplateLanguages[0].groupMappedToDistributorSite,
                            code: this.props.template.template.productTemplateLanguages[0].code,
                            name: this.props.template.template.productTemplateLanguages[0].name,
                            description: this.props.template.template.productTemplateLanguages[0].description,
                            active: this.props.template.template.productTemplateLanguages[0].active,
                            startDate: this.props.template.template.productTemplateLanguages[0].startDate,
                            endDate: this.props.template.template.productTemplateLanguages[0].endDate,
                            manufacturerPartNumber: this.props.template.template.productTemplateLanguages[0].manufacturerPartNumber,
                            gtin: this.props.template.template.productTemplateLanguages[0].gtin,
                            overrideImageBaseName: this.props.template.template.productTemplateLanguages[0].overrideImageBaseName,
                            swatchImageName: this.props.template.template.productTemplateLanguages[0].swatchImageName, 
                            colorSwatch: this.props.template.template.productTemplateLanguages[0].colorSwatch,
                            colorTraitName: this.props.template.template.productTemplateLanguages[0].colorTraitName,
                            colorTraitValue: this.props.template.template.productTemplateLanguages[0].colorTraitValue,
                            trait1Name: this.props.template.template.productTemplateLanguages[0].trait1Name,
                            trait1Value: this.props.template.template.productTemplateLanguages[0].trait1Value,
                            trait2Name: this.props.template.template.productTemplateLanguages[0].trait2Name,
                            trait2Value: this.props.template.template.productTemplateLanguages[0].trait2Value,
                            minimumQty: this.props.template.template.productTemplateLanguages[0].minimumQty,
                            maximumQty: this.props.template.template.productTemplateLanguages[0].maximumQty,
                            inStockQuantity: this.props.template.template.productTemplateLanguages[0].inStockQuantity,
                            weight: this.props.template.template.productTemplateLanguages[0].weight,
                            showQuoteButton: this.props.template.template.productTemplateLanguages[0].showQuoteButton,
                            showBuyButton: this.props.template.template.productTemplateLanguages[0].showBuyButton,
                            hidePriceUntilCart: this.props.template.template.productTemplateLanguages[0].hidePriceUntilCart,
                            regularPrice: this.props.template.template.productTemplateLanguages[0].regularPrice,
                            salePrice: this.props.template.template.productTemplateLanguages[0].salePrice,
                            msrpPrice: this.props.template.template.productTemplateLanguages[0].msrpPrice,
                            mapPrice: this.props.template.template.productTemplateLanguages[0].mapPrice
                        }
                    ]
                }
            });

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    startImport(e) {
        document.getElementById("fileChooseButtonTemplate").click();
    }
    startExport(e) {
        var formulas = []

        for (let [key, value] of Object.entries(this.props.template.formulas)) {
            formulas.push({
                name: key,
                formulaResult: value.formulaResult
            })
        }

        exportTemplate.bind(this)(e.currentTarget.attributes.template.value, formulas)
    }

    onImport(event) {
        var files = event.target.files;

        var mimeType = event.target.files[0]['type'];
        if (mimeType !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            alert("The File uploaded must be an excel spreadsheet wtih the file extension .xlsx");
            document.getElementById("fileChooseButtonTemplate").value = null;
            return;
        }

        var i, f, j, k;
        var coreArray = {};

        //Loop through files
        for (i = 0, f = files[i]; i !== files.length; ++i) {
            var name = f.name;
            const reader = new FileReader();
            reader.onload = (evt) => {
                /* Parse data */
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                // const data = XLSX.utils.sheet_to_csv(ws, { header: 1 }); 
                const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                /* Update state */

                var header1 = data[0][0];
                var header2 = data[0][1];
 
                if (header1.toUpperCase() !== "FIELD" || header1 === undefined) {
//                    importError.bind(this)("Missing Field column")
                    return;
                }
                if (header2.toUpperCase() !== "VALUE" || header2 === undefined) {
//                    importError.bind(this)("Missing Value column")
                    return;
                }

                for (k = 1; k < data.length; k++) {
                    var header = data[k][0];
                    var value = data[k][1];

                    if (value === undefined || value === "undefined") {
                        value = "";
                    }

                    coreArray[header] = value;
                }

                console.log(JSON.stringify(coreArray));
                importTemplate.bind(this)(this.props.template.template.productTemplateId, coreArray);

            };
            reader.readAsBinaryString(f);
        }
    }

    updateTemplate(e) {
        $('button.template').attr('disabled', 'disabled')

        let create = e.target.attributes.create.value;
        let draft = e.target.attributes.draft !== undefined;
        let template = {
            name: $('#template_name').val().trim(),
            filter: $('#template_filter').val(),
            websiteCategory1: $('select.web1').val(),
            websiteCategory2: $('select.web2').val(),
//&?            priority: parseInt($('#template_priority').val()),
            productSeriesId: parseInt($('select.series').val()),
            groupMetaClassName: $('select.grpmeta').val(),
            metaClassName: $('select.meta').val(),
            groupPageLayoutDefault: $('select.layout').val(),
            productTemplateLanguages: [
                {
                    language: "en",

                    groupCode: $('textarea[name="groupCode"]').val(),
                    groupName: $('textarea[name="groupName"]').val(),
                    groupDescription: $('textarea[name="groupDescription"]').val(),
                    groupURL: $('textarea[name="groupURL"]').val(),
                    groupSEDescription: $('textarea[name="groupSEDescription"]').val(),
                    groupSETitle: $('textarea[name="groupSETitle"]').val(),
                    groupSEKeywords: $('textarea[name="groupSEKeywords"]').val(),
                    groupActive: $('textarea[name="groupActive"]').val(),
                    groupStartDate: $('textarea[name="groupStartDate"]').val(),
                    groupEndDate: $('textarea[name="groupEndDate"]').val(),
                    groupMappedToReicoSite: $('textarea[name="groupMappedToReicoSite"]').val(),
                    groupMappedToDistributorSite: $('textarea[name="groupMappedToDistributorSite"]').val(),
                    code: $('span[name="code"]').text(),
                    name: $('textarea[name="name"]').val(),
                    description: $('textarea[name="description"]').val(),
                    active: $('textarea[name="active"]').val(),
                    startDate: $('textarea[name="startDate"]').val(),
                    endDate: $('textarea[name="endDate"]').val(),
                    manufacturerPartNumber: $('textarea[name="manufacturerPartNumber"]').val(),
                    gtin: $('textarea[name="gtin"]').val(),
                    overrideImageBaseName: $('textarea[name="overrideImageBaseName"]').val(),
                    colorSwatch: $('textarea[name="colorSwatch"]').val(),
                    swatchImageName: $('textarea[name="swatchImageName"]').val(),
                    colorTraitName: $('textarea[name="colorTraitName"]').val(),
                    colorTraitValue: $('textarea[name="colorTraitValue"]').val(),
                    trait1Name: $('textarea[name="trait1Name"]').val(),
                    trait1Value: $('textarea[name="trait1Value"]').val(),
                    trait2Name: $('textarea[name="trait2Name"]').val(),
                    trait2Value: $('textarea[name="trait2Value"]').val(),
                    minimumQty: $('textarea[name="minimumQty"]').val(),
                    maximumQty: $('textarea[name="maximumQty"]').val(),
                    inStockQuantity: $('textarea[name="inStockQuantity"]').val(),
                    weight: $('textarea[name="weight"]').val(),
                    showQuoteButton: $('textarea[name="showQuoteButton"]').val(),
                    showBuyButton: $('textarea[name="showBuyButton"]').val(),
                    hidePriceUntilCart: $('textarea[name="hidePriceUntilCart"]').val(),
                    regularPrice: $('textarea[name="regularPrice"]').val(),
                    salePrice: $('textarea[name="salePrice"]').val(),
                    msrpPrice: $('textarea[name="msrpPrice"]').val(),
                    mapPrice: $('textarea[name="mapPrice"]').val()                    
                }
            ]
        };

        if (template.websiteCategory1 == 'Select')
            template.websiteCategory1 = '';
        if (template.websiteCategory2 == 'Select')
            template.websiteCategory2 = '';

        template.published = !draft ? 1 : 0

        if (create === 'true') {
            createTemplate.bind(this)(template);
        }
        else {
            template.productTemplateId = parseInt($('#template_id').text());
            updateTemplate.bind(this)(template.productTemplateId, template);
        }

        chkReturn = setInterval(this.closeTemplate, 100);
    }
    cancelTemplate() {
        this.props.dispatch(errorTemplate);

        this.setState({
            editTemplateMode: false
        });

        this.props.dispatch(fetchTemplatesList);
    }
    closeTemplate() {
        if (this.props.template.updated || this.props.template.error) {
            if (this.canDraft()) $('button.draft').removeAttr('disabled')
            if (this.canPublish()) $('button.publish').removeAttr('disabled')

            if (this.props.template.updated) {
                this.cancelTemplate();
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    search(e) {
        this.setState({ nameSrch: e.target.value.toLowerCase() }) 
    }

    closeFilterProducts() {
        this.setState({ showFilterProducts: false })
    }

    render() {
        return (
            <div className="product-templates col-xs-12">
                <CommError error={this.props.template.error} onClose={this.errorTemplateClear} />
                <CommError error={this.props.templates.error} onClose={this.fetchTemplateErrorClear} />

                <ConfirmModal open={this.props.templates.noData} heading={"Product Templates"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div className="product">
                        <h1>Product Templates</h1>
                    </div>
                </div>

                <div id="srch">
                    <span>Search by Name:</span>
                    {
                        this.props.templates.fetching ?
                            <input id="name" disabled />
                        :
                            <input id="name" autocomplete="off" spellcheck="false" onChange={this.search} />
                    }
                    <button className="btn btn-primary pull-right" onClick={this.templateCreate}>+ Create Template</button>
                </div>

                <div className="tableWrapper">
                    {
                        this.props.templates.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th>Template</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.templatesList ?
                                    this.props.templatesList.filter((template) => {
                                        if (this.state.nameSrch.length) {
                                            if (template.name.toLowerCase().startsWith(this.state.nameSrch)) {
                                                template.prefix = template.name.substring(0, this.state.nameSrch.length)
                                                template.suffix = template.name.substring(this.state.nameSrch.length)

                                                return true
                                            }
                                            else
                                                return false
                                        }
                                        else return true
                                    }).map((template, index) => {
                                        return <tr className="body" key={index}>
                                            <td className="name" template={template.productTemplateId} onClick={this.templateEdit}>
                                                {this.state.nameSrch.length ? <p><span className="srch">{template.prefix}</span><span>{template.suffix}</span></p> : template.name}
                                            </td>
                                            <td>{template.published === 1 ? "Published" : "Unpublished"}</td>
                                            <td className="actions">
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                    <i className="fa fa-edit" template={template.productTemplateId} onClick={this.templateEdit} style={{}}></i>
                                                </OverlayTrigger>
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Copy</Tooltip>}>
                                                    <i className="fa fa-files-o" template={template.productTemplateId} onClick={this.templateCreate}></i>
                                                </OverlayTrigger>
                                            </td>
                                        </tr>
                                    })
                                : null
                            }
                        </tbody>
                    </table>
                </div>

                <CreateEditTemplate
                    errTemplate={this.props.template}
                    errTemplateClear={this.errorTemplateClear}

                    seriesList={this.props.seriesList}

                    curTemplate={this.props.template.template}
                    tmpTemplate={this.state.template}

                    create={this.state.editTemplate}
                    isOpen={this.state.editTemplateMode}

                    onAfterOpen={this.afterOpen}

                    showFilterProducts={this.state.showFilterProducts}
                    closeFilterProducts={this.closeFilterProducts}

                    onRequestImport={this.startImport}
                    onRequestExport={this.startExport}
                    onRequestClose={this.updateTemplate}
                    onRequestCancel={this.cancelTemplate}

                    onImport={this.onImport}

                    onSeries={this.onSeries}
                    onChange={this.onChange}
                    onChange2={this.onChange2}

                    filter={this.props.template.filter}
                    filterErr={this.props.template.error}
                    validateSQL={this.validateSQL}
                    productsWithDifferentTemplateId={this.findProductsWithDifferentTemplateId()}

                    calculateProductGroupCount={this.calculateProductGroupCount}
                    productGroupCount={this.props.template.productGroupCount}

                    formulas={this.props.template.formulas}
                    formulaValidate={this.formulaValidate}

                    canPublish={this.state.canPublish}
                    canDraft={this.state.canDraft}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    template: state.template,
    templates: state.templates,
    seriesList: state.series.seriesSortedList
});

export default connect(mapStateToProps)(Templates)

